<template>
  <div>
    <v-row justify="center" class="my-10">
      <v-col cols="12" sm="4">
        <v-card class="elevation-card rounded-12 mb-5">
          <v-card-title>
            <v-icon color="primary2" class="mr-2">
              mdi-web
            </v-icon>
            <span class="fs-14 font-weight-bold primary2--text">
              Get Access
            </span>
            <v-spacer />
          </v-card-title>
          <v-divider />
          <validation-observer v-slot="{ handleSubmit }">
            <form class="pa-4" @submit.prevent="handleSubmit(login)">
              <v-alert class="fs-14" type="error" v-if="error">
                {{ error }}
              </v-alert>
              <ValidationProvider
                slim
                name="NIK"
                rules="required"
                v-slot="{ errors }"
              >
                <label class="mb-1 d-block fs-12 font-weight-regular" for="nik">
                  NIK
                </label>
                <v-text-field
                  id="nik"
                  placeholder="Input NIK"
                  single-line
                  dense
                  outlined
                  :error-messages="errors"
                  v-model="nik"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                slim
                name="Password"
                rules="required"
                v-slot="{ errors }"
              >
                <label
                  class="mb-1 d-block fs-12 font-weight-regular"
                  for="password"
                >
                  Password
                </label>
                <v-text-field
                  id="password"
                  placeholder="Password"
                  single-line
                  dense
                  outlined
                  :error-messages="errors"
                  v-model="password"
                  type="password"
                ></v-text-field>
              </ValidationProvider>
              <v-btn
                :loading="loading"
                type="submit"
                large
                block
                color="primary"
              >
                Get Access
              </v-btn>
            </form>
          </validation-observer>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    error: '',

    nik: '',
    password: '',

    breadcrumbs: [
      {
        text: 'SSHCF',
        to: '/'
      },
      {
        text: 'Get Access',
        disabled: false
      }
    ]
  }),
  methods: {
    async login() {
      this.loading = true;
      const res = await this.$store.dispatch('sshcf/login', {
        nik: this.nik,
        password: this.password
      });
      if (res.code === 200) {
        localStorage.setItem('SSHCF_TOKEN', res.data.token);
        this.$router.push('/sshcf/requests/create?t=1');
      } else {
        this.error = res.message.text_en || 'Failed to authenticate';
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
